import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { scaleIn400ms } from '../../../../../@vex/animations/scale-in.animation';
import { fadeInRight400ms } from '../../../../../@vex/animations/fade-in-right.animation';
import { stagger40ms } from '../../../../../@vex/animations/stagger.animation';
import { fadeInUp400ms } from '../../../../../@vex/animations/fade-in-up.animation';
import { scaleFadeIn400ms } from '../../../../../@vex/animations/scale-fade-in.animation';
import { Router } from '@angular/router';
import { AuthService } from '../../../services/auth.service';
import { MatLegacyTableDataSource as MatTableDataSource } from '@angular/material/legacy-table';
import { ProductModel } from '../../../models/product.model';
import { PrestationModel } from '../../../models/prestation.model';
import { FeiColumn } from '../../interfaces/fei-column.interface';
import icPlus from '@iconify/icons-ic/twotone-plus';
import icMinus from '@iconify/icons-ic/twotone-minus';
import icDelete from '@iconify/icons-ic/twotone-delete';
import { BasketModel } from '../../../models/basket.model';
import { BasketRowStatusEnum } from '../../../enums/basketRowStatusEnum';
import { TicketService } from '../../../../pages/application/administrative/ticket/ticket.service';
import icFileCopy from '@iconify/icons-ic/twotone-file-copy';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { MoreInfoModalComponent } from '../../../../pages/application/administrative/ticket/modals/more-info-modal/more-info-modal.component';
import { hasMoreInfo } from '../../../utils/catalog-reference.utils';
import { ReferenceContractsModel } from '../../../models/reference-contracts.model';
import { BasketItemHelper } from '../../../helpers/basket-item.helper';
import { QuantityChange } from '../quantity-stepper/quantity-stepper.component';

@Component({
  selector: 'list-services-base',
  templateUrl: 'list-services-base.component.html',
  animations: [scaleIn400ms, fadeInRight400ms, stagger40ms, fadeInUp400ms, scaleFadeIn400ms],
  styleUrls: ['list-services-base.component.scss'],
})
export class ListServicesBaseComponent implements OnInit {
  hasMoreInfo = hasMoreInfo;

  // feisColumns: Array<FeiColumn>;
  // prestationEmpty: boolean = false;
  // articleEmpty: boolean = false;

  constructor(
    private router: Router,
    public authService: AuthService,
    private ticketService: TicketService,
    private dialog: MatDialog,
  ) {}

  @Input() dataSource!: MatTableDataSource<ProductModel | PrestationModel>;
  @Input() feisColumns!: Array<FeiColumn>;
  @Input() count!: number;
  @Input() pageSize: number;
  @Input() displayedColumnsCatalog: Array<string>;
  @Input() pageIndex!: number;
  @Input() basket?: BasketModel;
  @Input() canDeleteAllRow: boolean = false;
  @Input() disabled: boolean = true;
  @Input() isCompetence: boolean = false;
  @Input() quantityStep: number = 1;
  @Input() quantityMax: number = 9999;
  /** PRED-3286 : ticket COMPETENCE calculé → quantité (= quantityMax) affichée en lecture seule, sans stepper. */
  @Input() quantityReadonly: boolean = false;
  /** Heures par jour du ticket, pour l'équivalent en jours (repli 7h). */
  @Input() hoursPerDay: number;
  @Output() onUpdateItemQuantityFromCatalogEvent = new EventEmitter<any>();
  @Output() onAddToBasketEvent = new EventEmitter<any>();
  @Output() onPageEvent = new EventEmitter();
  @Output() onSortEvent = new EventEmitter();
  @Output() onTabChangeEvent = new EventEmitter();
  @Output() onDeleteEvent = new EventEmitter<any>();

  // displayedColumnsArticle: any;
  // displayedColumnsPrestation: any;

  // Tri courant affiché dans l'en-tête (ex. restauré depuis l'URL, PRED-3175)
  @Input() sortField: string;
  @Input() sortOrder: string;
  showComment: string | boolean = false;
  showPreviousReference: string | boolean = false;

  protected readonly icPlus = icPlus;
  protected readonly icMinus = icMinus;
  readonly icDelete = icDelete;
  readonly icFileCopy = icFileCopy;
  protected readonly basketRowStatusEnum = BasketRowStatusEnum;

  ngOnInit() {
    this.displayedColumnsCatalog = this.feisColumns.map((feiColumn: FeiColumn) => feiColumn.column);
  }

  canDelete(row: any): boolean {
    if (!this.basket) {
      return false;
    }

    const prestations = this.basket.prestations || [];
    const products = this.basket.products || [];

    const matchesReference = (p: any) => p._id === row._id || p.referenceId?.toString() === row._id;
    const isInBasket = prestations.some(matchesReference) || products.some(matchesReference);

    if (!isInBasket) {
      return false;
    }

    if (this.canDeleteAllRow) {
      return true;
    }

    let status: BasketRowStatusEnum = BasketRowStatusEnum.ORDERED;

    if (this.ticketService.isProduct(row)) {
      const product = products.find(matchesReference);
      status = product?.status;
    } else {
      const prestation = prestations.find(matchesReference);
      status = prestation?.status;
    }

    return status !== BasketRowStatusEnum.UNAVAILABLE;
  }

  updateCatalogueQuantity(element, direction: string) {
    this.dataSource = new MatTableDataSource(
      this.dataSource.data.map((entity: any) => {
        if (entity._id === element._id) {
          if (direction === 'minus' && entity.quantity === 1) {
            return entity;
          }
          if (direction === 'change') {
            return entity;
          }
          if (direction === 'plus' && entity.quantity === 9999) {
            return entity;
          }
          direction === 'plus' ? entity.quantity++ : entity.quantity--;
        }
        return entity;
      }),
    );
  }

  /**
   * Applique le changement émis par le quantity-stepper (tickets COMPETENCE) à la
   * ligne de catalogue. La valeur est déjà bornée à [step, max] par le stepper.
   */
  onCatalogStepperChange(row: any, change: QuantityChange) {
    BasketItemHelper.applyQuantityChange(row, change.quantity, change.direction);
  }

  /** Quantité (heures) convertie en jours, pour l'affichage sous le stepper. */
  quantityInDays(quantity: number): number {
    return BasketItemHelper.hoursToDays(quantity, this.hoursPerDay);
  }

  deleteReference(element) {
    this.dataSource = new MatTableDataSource(
      this.dataSource.data.map((entity: any) => {
        if (element._id === entity._id) {
          entity.quantity = 1;
        }
        return entity;
      }),
    );
    this.onDeleteEvent.emit(element);
  }

  openMoreInfoModal(row: any) {
    this.dialog.open(MoreInfoModalComponent, {
      width: '500px',
      data: {
        data: row,
      },
    });
  }
}
